import type { CompanyStatus } from '@planuze/admin-contracts';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@planuze/ui';
import { useCompaniesContent } from '../../content/sections/companies.js';
import { SearchInput } from '../search-input.js';

export type StatusFilter = CompanyStatus | 'all';

interface FiltersValue {
  readonly search: string;
  readonly status: StatusFilter;
}

interface Props {
  readonly value: FiltersValue;
  readonly onChange: (value: FiltersValue) => void;
}

/* Toolbar da lista de empresas (ADR-0702): SearchInput padrão + filtro de status. Espaçamento
   fica a cargo do PageContent (space-y) — sem margens locais. */
export function CompaniesFilters({ value, onChange }: Props) {
  const copy = useCompaniesContent();
  return (
    <div className="flex flex-wrap items-center gap-3">
      <SearchInput
        value={value.search}
        onChange={(search) => onChange({ ...value, search })}
        ariaLabel={copy.filters.searchLabel}
        placeholder={copy.filters.searchPlaceholder}
      />
      <Select
        value={value.status}
        onValueChange={(status) => onChange({ ...value, status: status as StatusFilter })}
      >
        <SelectTrigger className="w-40" aria-label={copy.filters.statusFilterLabel}>
          <SelectValue placeholder={copy.filters.statusPlaceholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{copy.filters.statusAll}</SelectItem>
          <SelectItem value="active">{copy.status.active}</SelectItem>
          <SelectItem value="trial">{copy.status.trial}</SelectItem>
          <SelectItem value="blocked">{copy.status.blocked}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
